import styled from 'styled-components';

import { FlexDiv, GenericDiv } from 'commonStyles';

export const CardWrapper = styled(FlexDiv)`
	padding: 16px;
	margin: 0 24px 24px 0;
	min-height: 281px;
`;

export const CardContainer = styled(GenericDiv)`
	scroll-margin: 60px;
`;
